/**
 *
 * @param {Boolean} editable  is column editable
 * @param {Boolean} sortable  is column sortable
 * @param {Boolean} hasError if clumn has an error while editing
 * @param {Object} icon Object has properties name,size,state,type (please refer Icon component)
 */
export default function DataTableColumn(
	editable = true,
	sortable = true,
	hasError = false,
	icon = {
		name: "i-a",
		size: "small",
		state: "font-light",
		type: "filled"
	}
) {
	this.hasError = hasError;
	this.editable = editable;
	this.icon = icon;
	this.sortable = sortable;
}
